import BarChart from './BarCharts';

export default BarChart;